
define('jst!contacts/tour/_step2',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<h1><%= t("Actions #contactsfeaturetour") %></h1>\n\n<p><%= t("Go here to see people\'s profile, send them messages and tasks - you can even invite them to a workspace! #contactsfeaturetour") %></p>\n');
 });

